// extracted by mini-css-extract-plugin
export default {"btn":"complain-btn_btn__ZzzKD"};